import Async from 'react-select/lib/Async';
import { connect } from 'react-redux';
import { primary_s20_l95 } from '../../shared/lib/colors';
import { jsx, css } from '@emotion/core';

import './AsyncSelect.scss';

const getStyle = ({ primaryColor, isHeader = false, uiVariantInputText }) => {
  return css`
    &.is-focused:not(.is-open),
    &.is-open {
      .Select-control {
        border-color: ${primaryColor};
      }
    }
    .Select-value {
      padding-left: 30px !important;
    }

    .Select-value,
    .Select-placeholder,
    .Select-noresults {
      padding-top: 11px;
      padding-left: 32px !important;
      padding-bottom: 11px;
      align-items: center;
      display: flex;
    }

    .Select-control {
      height: 45px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #ececec !important;

      @media (min-width: 992px) {
        height: ${isHeader ? '45px' : '40px'};
      }

      .Select-input {
        input {
          position: absolute;
          top: 0px;
          right: 0%;
          padding-left: 32px;
          font-size: 16px;
        }
      }

      .Select-clear-zone {
        .Select-clear {
          margin-left: 100px;
        }
      }

      .Select-arrow-zone {
        .Select-arrow {
          border-color: ${primaryColor} transparent transparent;
          // background-color: ${primaryColor};
          svg {
            color: #ffff;
          }
        }
      }
    }
    &.is-open {
      .Select-control {
        .Select-arrow {
          border-color: transparent transparent ${primaryColor};
        }
      }
    }

    .Select-menu-outer {
      border-color: ${primaryColor};
      background-color: #f8f8f8;
    }

    .Select-option {
      padding: ${isHeader ? 0 : '5px 15px'};

      &.is-selected,
      &.is-focused {
        background-color: ${primary_s20_l95(primaryColor)};
      }
    }
  `;
};

const AsyncSelect = props => <Async css={getStyle(props)} {...props} />;

const mapStateToProps = state => ({
  primaryColor: state.store.data.loghiTemplate.brandColor,
  uiVariantInputText: state.store.data.uiVariants.inputText,
});

export default connect(mapStateToProps)(AsyncSelect);
